import "./Imprint.module.css";
import Header from "@/reusable_sections/Header";
import Impressum from "./sections/Impressum";
import LegalInformation from "./sections/LegalInformation";
import Footer from "@/reusable_sections/Footer";
export default function ImprintPage() {
  return <div>
      <Header />
      <Impressum />
      <LegalInformation />
      <Footer />
    </div>;
}